// Pageview event for every page
dataLayer.push({
  event: "Pageview",
  pagePath: window.location.href,
  pageTitle: document.title,
});

document.addEventListener("DOMContentLoaded", function () {
  $(".ais-InfiniteHits-loadMore").click(function () {
    dataLayer.push({
      event: "Pageview",
      pagePath: window.location.href,
      pageTitle: document.title,
    });
  });
});
